<template>
  <div class="scene">
    <div class="header">
      <div class="title">方案场景描述</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in sceneList" :key="item.id">
          <img :src="item.logo" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import scene1 from "../../../../assets/programme/scene1.png";
import scene2 from "../../../../assets/programme/scene2.png";
import scene3 from "../../../../assets/programme/scene3.png";
import scene4 from "../../../../assets/programme/scene4.png";

export default {
  setup() {
    return reactive({
      sceneList: [
        {
          id: 1,
          title: "物业远程监控  多种监控方式",
          text: "远程用户收到警情电话、信息后可以通过上网手机或电脑查看监控画面情况，并通过手机控制摄像机旋转角度及焦距、报警系统布防撤防，同时启动手机录像功能并处理警情",
          logo: scene1,
        },
        {
          id: 2,
          title: "人形人脸人声自动识别  AI智能分析",
          text: "支持面部检测；支持体温测量；支持人脸识别，可实现无感通行；基于结构化的AI行为分析算法，通过大数据分析计算，结合系统设定的参数，识别判断人的各种异常行为，并通过后台预警、弹窗、智能语音提示",
          logo: scene2,
        },
        {
          id: 3,
          title: "红外夜视效果  画面清晰",
          text: "高速数据处理能力进行视频的采集和处理，从而大大提高了图像质量，增强了视频监控的功能",
          logo: scene3,
        },
        {
          id: 4,
          title: "自动防御系统升级  增强社区安全性",
          text: "每天连续24小时的实时智能监视，并自动分析摄像机捕捉的图像数据，当异常发生时，系统能向保卫人员准确及时地发出警报",
          logo: scene4,
        },
      ],
    });
  },
};
</script>

<style scoped>
.scene {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
}
.body .list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.body .list .item {
  width: 570px;
  margin-bottom: 40px;
  text-align: center;
  border: 1px solid #d5e3fa;
  overflow: hidden;
}
.body .list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.body .list .item img {
  width: 570px;
}
.body .list .item .title {
  font-size: 24px;
  color: #248efb;
  margin-top: 40px;
}
.body .list .item .text {
  padding: 0 36px;
  font-size: 14px;
  color: #495a6c;
  margin: 20px auto 40px;
}
</style>
